/**
 * Dias entre hoje e o prazo.
 *
 * Aritmetica de calendario, calculada no cliente APENAS para o texto do selo
 * ("Atrasada 12 dias"). A CLASSIFICACAO em atrasado, proximo do vencimento ou no prazo
 * continua sendo do servidor, em `saudeDoPrazo`: ela depende da janela de atencao
 * configurada em `negocio.janelaVencimentoDias`, que o cliente nao conhece.
 *
 * A conta usa `Date.UTC` nos dois lados para nao depender do fuso: o que interessa e a
 * diferenca entre duas datas de calendario, e converter fuso no meio introduziria um dia
 * de erro perto da meia-noite.
 */
export function diasAte(prazo: string | null): number | null {
  if (prazo === null) {
    return null;
  }

  const [ano, mes, dia] = prazo.slice(0, 10).split('-').map(Number);

  if (ano === undefined || mes === undefined || dia === undefined) {
    return null;
  }

  const agora = new Date();
  const hoje = Date.UTC(agora.getFullYear(), agora.getMonth(), agora.getDate());

  return Math.round((Date.UTC(ano, mes - 1, dia) - hoje) / 86_400_000);
}
